import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { trackMortgageProgramClick, trackMortgageProgramsListShow } from './tracking';
import { MortgagePrograms } from '../../components/MortgagePrograms';
import { selectMortgagePrograms } from '../../selectors/mortgagePrograms';

export const MortgageProgramsContainer = (): React.JSX.Element | null => {
  const mortgagePrograms = useSelector(selectMortgagePrograms);
  const deviceType = useDeviceType();

  if (!mortgagePrograms.length) {
    return null;
  }

  return (
    <MortgagePrograms
      deviceType={deviceType}
      mortgagePrograms={mortgagePrograms}
      onMortgageProgramsListShow={trackMortgageProgramsListShow}
      onMortgageProgramClick={trackMortgageProgramClick}
    />
  );
};
